import React, {useEffect} from "react";

import {useLocation, NavLink} from "react-router-dom";

import PropTypes from "prop-types";

import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

import MDBox from "../MDBox";
import MDTypography from "../MDTypography";

import SidenavRoot from "./SidenavRoot";
import sidenavLogoLabel from "./styles/sidenav";

import {
    useMaterialUIController, setMiniSidenav, setTransparentSidenav, setWhiteSidenav,
} from "../../Context/mui";
import Collapsechilds from "./Sidenavcollapsechilds";
import SidenavCollapse from "./SidenavCollapse";
import {CanAccess} from "../../utils/tools/AuthCheck";

function Sidenav({color, brand, brandName, routes, ...rest}) {
    const [controller, dispatch] = useMaterialUIController();
    const {miniSidenav, transparentSidenav, whiteSidenav, darkMode} = controller;
    const location = useLocation();
    const   collapseName = location.pathname.replace("/", "");
     
    let textColor = "dark";

    if (transparentSidenav || (whiteSidenav && !darkMode)) {
        textColor = "dark";
    } else if (whiteSidenav && darkMode) {
        textColor = "inherit";
    }

    const closeSidenav = () => setMiniSidenav(dispatch, true);
    brand = require("../../Asset/images/hospital.png");
    useEffect(() => {
        function handleMiniSidenav() {
            setMiniSidenav(dispatch, window.innerWidth < 1200);
            setTransparentSidenav(dispatch, window.innerWidth < 1200 ? false : transparentSidenav);
            setWhiteSidenav(dispatch, window.innerWidth < 1200 ? false : whiteSidenav);
        }

        window.addEventListener("resize", handleMiniSidenav);

        handleMiniSidenav();

        return () => window.removeEventListener("resize", handleMiniSidenav);
    }, [dispatch, location]);


    const renderRoutes = routes.map(({
                                         type,
                                         name,
                                         icon,
        img,
                                         title,
                                         noCollapse,
                                         key,
                                         href,
                                         route,
                                         childs,
                                         level,
                                         childRoutes,
                                     }) => {
        let returnValue;
        if (type == "collapse" && CanAccess(level)) returnValue = (<React.Fragment key={key}>
            <NavLink to={route}>
                <SidenavCollapse
                    name={name}
                    icon={icon}
                    img={img}
                    active={key === collapseName}
                />
            </NavLink>
            <Divider
                light={(!darkMode && !whiteSidenav && !transparentSidenav) || (darkMode && !transparentSidenav && whiteSidenav)}
            />
        </React.Fragment>)
        return returnValue;
    });

    return (<SidenavRoot
            {...rest}
            variant="permanent"
            ownerState={{transparentSidenav, whiteSidenav, miniSidenav, darkMode}}
        >
            <MDBox pt={3} pb={1} px={4} className="fcontainer" textAlign="center">
                <MDBox
                    display={{xs: "block", xl: "none"}}
                    position="absolute"
                    top={0}
                    right={0}
                    p={1.625}
                    onClick={closeSidenav}
                    sx={{cursor: "pointer"}}
                >
                    <MDTypography variant="h6" color="secondary">
                        <Icon sx={{fontWeight: "bold"}}>close</Icon>
                    </MDTypography>
                </MDBox>
                <MDBox component={NavLink} to="/" display="flex" alignItems="center">
                    {brand && (<MDBox
                            component="img"
                            src={brand}
                            sx={{
                                borderRadius: "100%", padding: "4px", background: "rgba(215,215,215,0.56)",
                            }}
                            alt="Brand"
                            width="3.125rem"
                        />)}
                    <MDBox
                        width={!brandName && "100%"}
                        sx={(theme) => sidenavLogoLabel(theme, {miniSidenav})}
                    >
                        <MDTypography
                            component="h6"
                            variant="button"
                            fontWeight="medium"
                            fontSize={20}
                            color={textColor}
                        >
                            قهرمان سلامت
                        </MDTypography>
                    </MDBox>
                </MDBox>
            </MDBox>
            <Divider
                light={(!darkMode && !whiteSidenav && !transparentSidenav) || (darkMode && !transparentSidenav && whiteSidenav)}
            />
            <List className="fcontainer">{renderRoutes}</List>
        </SidenavRoot>);
}

// Setting default values for the props of Sidenav

// Typechecking props for the Sidenav

export default Sidenav;
